import React from 'react';
import { useLazyQuery, useMutation, gql } from '@apollo/client';
import MoveUnserialized from './MoveUnserialized';
import { useRootStore } from '@/lib/providers/RootProvider';

const CLIENT_PRODUCT_ZONE_INVENTORY_BALANCES = gql`
  query paginatedZoneInventoryBalancesByZone($zoneId: ID!, $companyId: ID!) {
    unserializedPaginatedZoneInventoryBalancesByZone(
      zoneId: $zoneId
      companyId: $companyId
      paginationAttributes: { limit: 10, skip: 0 }
    ) {
      zoneInventoryBalances {
        id
        stocked
        lot
        expiration
        zone {
          id
          name
        }
        product {
          id
          title
          fdaProduct {
            id
            name
            elevenDigitNdc
            deaSchedule
          }
          upcProduct {
            id
            upc
          }
        }
      }
      pagination {
        totalRecords
      }
    }
  }
`;

const MOVE_UNSERIALIZED_ITEMS = gql`
  mutation moveUnserializedItems(
    $companyId: ID!
    $moveUnserializedItemsAttributes: [MoveUnserializedItemsAttributes!]!
  ) {
    moveUnserializedItems(
      moveUnserializedItemsAttributes: $moveUnserializedItemsAttributes
      companyId: $companyId
    )
  }
`;

const MoveUnserializedData = (props) => {
  const clientId = useRootStore((state) => state.selectedCompany.id);
  const [moveUnserializedItems] = useMutation(MOVE_UNSERIALIZED_ITEMS);
  const [
    getClientProductZoneInventoryBalancesCurrentZone,
    {
      data: clientProductZoneInventoryBalancesDataCurrentZone,
      loading: zoneInventoryBalancesLoadingCurrentZone,
      error: zoneInventoryBalancesErrorCurrentZone
    }
  ] = useLazyQuery(CLIENT_PRODUCT_ZONE_INVENTORY_BALANCES, {
    fetchPolicy: 'network-only'
  });

  const {
    unserializedPaginatedZoneInventoryBalancesByZone: {
      zoneInventoryBalances: zoneInventoryBalancesCurrentZone = []
    } = {}
  } = clientProductZoneInventoryBalancesDataCurrentZone || {};

  return (
    <MoveUnserialized
      moveUnserializedItems={moveUnserializedItems}
      getClientProductZoneInventoryBalancesCurrentZone={
        getClientProductZoneInventoryBalancesCurrentZone
      }
      zoneInventoryBalancesCurrentZone={zoneInventoryBalancesCurrentZone}
      zoneInventoryBalancesLoadingCurrentZone={zoneInventoryBalancesLoadingCurrentZone}
      zoneInventoryBalancesErrorCurrentZone={zoneInventoryBalancesErrorCurrentZone}
      {...props}
    />
  );
};

export default MoveUnserializedData;
